import { render, staticRenderFns } from "./ProductEvaluation.vue?vue&type=template&id=31397bc9&"
import script from "./ProductEvaluation.vue?vue&type=script&lang=js&"
export * from "./ProductEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports